const listFields = {
  inverters: {
    key: 'list_inverters',
    name: 'solarPlant.inverters',
    label: 'list_inverters',
  },
  solarPanels: {
    key: 'list_panels',
    name: 'solarPlant.solarPanels',
    label: 'list_panels',
  },
};

export default listFields;
